import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ToggleStrokeAction extends AbstractProvidedClass {
    newState;

    constructor(provider, appearance, strokeColor, useStroke) {
        super(provider);

        this.appearance = appearance;
        this.strokeColor = strokeColor;
        this.newState = useStroke;
        this.strokeWidth = this.appearance.strokeWidth;
    }

    finish() {
        this.appearance.strokeColor = this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.strokeWidth = this.newState ? this.strokeWidth : null;
        this.appearance.parent.row.updateImg();
        this.actions.finish();
    }

    undo() {
        this.appearance.strokeColor = !this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.strokeWidth = !this.newState ? this.strokeWidth : null;
        this.appearance.parent.row.updateImg();
    }

    redo() {
        this.appearance.strokeColor = this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.strokeWidth = this.newState ? this.strokeWidth : null;
        this.appearance.parent.row.updateImg();
    }
}
